import PropTypes from 'prop-types'
import { Text } from 'src/Components'
import { formatCurrency, formatNumber } from 'src/helpers/formatters'
import { sqftToAcres, centsToDollars } from 'src/helpers/converters'
import { isLandPropertyType } from 'src/helpers/listings'
import Stat from './Stat'

import styles from './PropertyStats.module.scss'

const propTypes = {
  listing: PropTypes.shape({
    sqft: PropTypes.shape({
      sqftLot: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      sqftBuilding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    priceCents: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    priceCentsSqft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    propertyType: PropTypes.string,
    roomsCounter: PropTypes.shape({
      bedroomsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      bathroomsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }),
}

const PropertyStats = ({ listing }) => {
  const lotSizeAcres = sqftToAcres(listing.sqft?.sqftLot).toFixed(2)
  const priceDollars = formatCurrency(centsToDollars(listing.priceCents))
  const priceDollarsSqft = formatCurrency(
    Math.ceil(centsToDollars(listing.priceCentsSqft))
  )
  const propertyIsLand = isLandPropertyType(listing.propertyType)
  const bds = listing.roomsCounter?.bedroomsCount
  const baths = listing.roomsCounter?.bathroomsCount
  const sqft = listing.sqft?.sqftBuilding || 0

  return (
    <>
      <div className={styles.prices}>
        <div className={styles.price}>
          <Text
            weight='bold'
            size='xl'
            variant='neutralCool'
            variantCount='900'
          >
            {priceDollars}
          </Text>
        </div>
        <div className={styles.pricePerSqft}>
          {!propertyIsLand && priceDollarsSqft && (
            <>
              <Text
                element='span'
                weight='semibold'
                variant='neutralCool'
                variantCount='800'
                size='xs'
              >
                {priceDollarsSqft}
              </Text>
              <Text
                element='span'
                size='tiny'
                variant='neutralCool'
                variantCount='800'
              >
                {' '}
                / ft²
              </Text>
            </>
          )}
        </div>
      </div>

      <div>
        <Text
          element='span'
          weight='semibold'
          size='xs'
          variant='neutralCool'
          variantCount='800'
        >
          {listing.propertyType}
        </Text>
      </div>

      <div className={styles.mainStats}>
        {!(propertyIsLand && bds <= 0) && <Stat value={bds} label='beds' />}
        {!(propertyIsLand && baths <= 0) && (
          <Stat value={baths} label='baths' />
        )}
        {!(propertyIsLand && sqft <= 0) && (
          <Stat value={formatNumber(sqft)} label='ft²' />
        )}
        <Stat value={lotSizeAcres} label='acres' />
      </div>
    </>
  )
}

PropertyStats.propTypes = propTypes

export default PropertyStats
